import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import Home from './pages/Home.tsx';
import Contact from './pages/Contact.tsx';
import CursorFollower from "./components/common/cursorFollower/CursorFollower.tsx";
import { Analytics } from "@vercel/analytics/react"

const App = () => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    link.href = 'Logo.png';

    // Remove old favicon if it exists
    const oldLink = document.querySelector("link[rel='icon']");
    if (oldLink) {
      document.head.removeChild(oldLink);
    }

    document.head.appendChild(link);
  }, []);
  return (
    <div className="min-h-screen bg-surface">
      <CursorFollower />
      <Analytics />
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path='contact' element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App; 